import { useEffect, useCallback } from 'react';

const useDebounce = (effect: () => void, dependencies: Array<any>, delay: number) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const callback = useCallback(effect, dependencies);
    useEffect(() => {
        if(dependencies[0].length>0){
            const timeout = setTimeout(callback, delay);
            return () => clearTimeout(timeout);
        }else{
            callback()
        }
    }, [callback, delay]);
}
export default useDebounce;